import React, { useMemo } from "react";
import {
  GreenEllipse,
  RedEllipse,
} from "../../../../../Icons";
import SelectedCheckIcon from "../../../../../Common/SelectedCheckIcon";
// import { GetCurrenySymbol } from "../../../../../../helper";

const CardItem = ({ card, activeCardId }) => {
  const { id, status, name, card_brand, card_provider, card_number } = card || {};
  const isActiveCard = id === activeCardId;
  const isCardActive = status === "Active";
  const provider = card_provider?.toLowerCase() || "";
  const brand = card_brand?.toLowerCase() || "";

  // ✅ Memoized image source
  const imageSrc = useMemo(() => {
    if (!isCardActive) {
      if (provider === "mm") return "assets/logos/virtual-card.png";
      if (provider === "em") return "assets/logos/emoney-card.png";
      return "assets/logos/blockedOtherCardBg-1.png";
    }

    if (brand === "visa") return "assets/logos/add-card-visa.png";
    if (provider === "em") return "assets/logos/emoney-card.png";
    return "assets/logos/virtual-card.png";
  }, [isCardActive, provider, brand]);

  const statusIcon = isCardActive ? <GreenEllipse /> : <RedEllipse />;
  const containerClasses = isActiveCard
    ? "bg-option-selected border-primary-300"
    : "bg-background-surface border-divider hover:bg-option-hover";

  return (
    <div
      key={id}
      className={`flex relative justify-between cursor-pointer border-2 shadow-sm rounded-3xl p-6 ${containerClasses}`}
    >
      {/* Selected Indicator */}
      {isActiveCard && (
        <SelectedCheckIcon />
      )}

      {/* Card Info */}
      <div className="flex items-center">
        <img
          src={imageSrc}
          alt="Card"
          className={`rounded-md ${!isCardActive ? "bg-zinc-400 opacity-60" : ""}`}
        />
        <div className="ml-3">
          <p className="text-text-primary text-sm font-medium max-w-[220px] whitespace-nowrap overflow-hidden text-ellipsis">
            {name}
          </p>
          <div className="flex items-center justify-center space-x-2">
            {statusIcon}
            <p className="text-text-secondary text-sm">
              {status} | ·· {card_number?.slice(-4)}
            </p>
          </div>
        </div>
      </div>

      {/* <div className="flex items-center justify-center space-x-0.5 text-text-primary text-sm font-medium leading-tight tracking-tight">
        <span>{GetCurrenySymbol("USD", "16", "16")}</span>
        <p className="text-text-primary font-normal">{card.balance}</p>
      </div> */}
    </div>
  );
};

export default React.memo(CardItem);
